import { useState, useEffect } from 'react';
import { doc, onSnapshot, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';

export const useBackgroundReconnect = (userId, historyId) => {
  const [reconnectState, setReconnectState] = useState({
    isReconnecting: false,
    existingAnalysis: null,
    backgroundProcessing: false,
    progress: 0
  });

  useEffect(() => {
    if (!userId || !historyId) return;

    const checkExistingAnalysis = async () => {
      try {
        // 해당 historyId로 직접 문서 가져오기
        const docRef = doc(db, "users", userId, "history", historyId);
        const docSnapshot = await getDoc(docRef);
        
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();

          // 백그라운드 처리 중인지 확인
          if (data.backgroundProcessing) {
            console.log('[Reconnect] Found background processing analysis:', historyId);
            
            setReconnectState({
              isReconnecting: true,
              existingAnalysis: { id: historyId, ...data },
              backgroundProcessing: true,
              progress: data.processingProgress || 0
            });
            


            // Firebase 실시간 리스너 설정
            const unsubscribe = onSnapshot(
              doc(db, "users", userId, "history", historyId),
              (snapshot) => {
                const updatedData = snapshot.data();
                const currentProgress = updatedData.processingProgress;
                console.log('[Reconnect] Firebase update:', {
                  progress: currentProgress,
                  status: updatedData.status,
                  backgroundProcessing: updatedData.backgroundProcessing
                });
                
                setReconnectState(prev => ({
                  ...prev,
                  existingAnalysis: { id: historyId, ...updatedData },
                  progress: currentProgress || prev.progress,
                  backgroundProcessing: updatedData.backgroundProcessing
                }));
                
                // 진행률 업데이트를 전역 함수로 전달 (ProgressModal 업데이트용)
                if (window.updateBackgroundProgress && currentProgress !== undefined) {
                  console.log('[Reconnect] 전역 함수로 진행률 업데이트:', currentProgress);
                  window.updateBackgroundProgress(currentProgress);
                }

                // 처리 완료 시
                if (updatedData.status === 'active' || !updatedData.backgroundProcessing) {
                  console.log('[Reconnect] Background processing completed', {
                    status: updatedData.status,
                    backgroundProcessing: updatedData.backgroundProcessing
                  });
                  
                  setReconnectState(prev => ({
                    ...prev,
                    backgroundProcessing: false,
                    progress: 100,
                    existingAnalysis: { id: historyId, ...updatedData }  // ✅ status 포함하여 업데이트
                  }));
                  
                  // 완료 시에도 전역 함수로 100% 전달
                  if (window.updateBackgroundProgress) {
                    console.log('[Reconnect] 완료 - 전역 함수로 100% 전달');
                    window.updateBackgroundProgress(100);
                  }
                }
              },
              (error) => {
                console.error('[Reconnect] Firebase listener error:', error);
              }
            );

            return () => unsubscribe();
          } 
          // 이미 완료된 분석이 있는 경우
          else if (data.status === 'active' && !data.backgroundProcessing) {
            console.log('[Reconnect] Found completed analysis:', historyId);
            
            setReconnectState({
              isReconnecting: false,
              existingAnalysis: { id: historyId, ...data },
              backgroundProcessing: false,
              progress: 100
            });
          }
        }
      } catch (error) {
        console.error('[Reconnect] Error checking existing analysis:', error);
      }
    };

    checkExistingAnalysis();
  }, [userId, historyId]);

  return reconnectState;
}; 